import { useWebsiteBuilder } from '../context/WebsiteBuilderContext';
import ContentPreview from '../components/ContentPreview';
import { usePageTracking } from '../../../hooks/usePageTracking';

export default function EditorStepPage() {
  const {
    pages, setPages, brandName, globalContactInfo, setGlobalContactInfo,
    isExported, triggerChargeConfirm, activePageId, setActivePageId,
    handleManualSave, saveStatus,
  } = useWebsiteBuilder();
  usePageTracking({ moduleName: 'Website Builder', submoduleName: 'Content', routePath: '/website-builder/editor' });

  return (
    <ContentPreview
      pages={pages}
      onPagesChange={setPages}
      brandName={brandName}
      globalContactInfo={globalContactInfo}
      setGlobalContactInfo={setGlobalContactInfo}
      isExported={isExported}
      onRequestUnlock={() => triggerChargeConfirm('unlock')}
      activePageId={activePageId}
      onActivePageIdChange={setActivePageId}
      onManualSave={handleManualSave}
      saveStatus={saveStatus}
    />
  );
}
